<template>
  <v-dialog v-model="showShare" max-width="290">
    <template v-slot:activator="{ on }">
      <v-btn
        fab
        depressed
        color="primary"
        small
        class="extra-small"
        v-on="on"
        style="margin-top: 10px"
      >
        <em class="fas fa-share" />
      </v-btn>
    </template>
    <v-card>
      <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
        >{{ $t('Link Copied') }}!</v-snackbar
      >
      <v-layout wrap>
        <v-flex xs8 class="headline pt-3 pl-3">{{ $t('Share product') }}</v-flex>
        <v-flex xs4 class="text-xs-right">
          <v-btn fab flat small @click="showShare = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-card-text>
        <textarea
          class="form-control pa-1"
          ref="shareLink"
          style="resize: vertical; width: 100%; border: 1px solid #eee"
          onclick="this.select()"
          readonly="true"
          v-model="message"
        ></textarea>
        <div class="text-xs-center">
          <v-btn
            depressed
            color="primary"
            v-clipboard:copy="message"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <span class="glyphicon glyphicon-file mr-1"></span>
            {{ $t('copy') }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['productid', 'pageid'],
  data: function () {
    return {
      showCopy: false,
      showShare: false
    }
  },
  computed: {
    id: function () {
      return this.productid
    },
    message: function () {
      return 'https://m.me/' + this.pageid + '?ref=askproduct_' + this.id
    }
  },
  mounted: function () {
    let vm = this
    vm.$refs.shareLink.click()
    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  },
  methods: {
    onCopy: function () {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onError: function () {}
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ModalShareLink.vue